var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { injectGlobal } from '@emotion/css';
export var injectGlobalStyles = function injectGlobalStyles() {
  return injectGlobal(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    body[data-moly-lock-scroll] {\n    overflow: hidden;\n    }\n"])));
};